

(function ($) {
    // Fade in effects
    // AOS.init();
    // Smooth anchor scrolling
    // var scroll = new SmoothScroll('a[href*="#"]', {
    //     speed: 300,
    // });

     $(".menu-toggle").on("click", function () {
        $(this).toggleClass("active");
        $("#wrapper-navbar").toggleClass("active");
        $(".container.mobile").toggleClass("active");
        $("html").toggleClass("scroll");
        $(".ticket-modal").removeClass('active');
        $(".circle-icons-mobile").toggleClass('active');
    });
    
    if ($(".imgs").length > 0) {
        var imgsswiper = new Swiper(".imgs", {
            slidesPerView: 1,
            center: false,
            loop: true,
            autoplay: true,
            pagination: {
                clickable: false,
            },
            navigation: {
                nextEl: ".imgs-next",
                prevEl: ".imgs-prev",
                clickable: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 500,
                },
                1024: {
                    spaceBetween: 500,
                },
            },
        });
    }


    if ($(".recensie").length > 0) {
        var reviewswiper = new Swiper(".swiper.recensie", {
            slidesPerView: 1,
            center: false,
            loop: false,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".recensie-next",
                prevEl: ".recensie-prev",
                clickable: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 500,
                },
                1024: {
                    spaceBetween: 500,
                },
            },
        });
    }


    if ($(".swiper-package").length > 0) {
        var packageswiper = new Swiper(".swiper-package", {
            slidesPerView: 1,
            center: false,
            loop: false,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".recensie-next",
                prevEl: ".recensie-prev",
                clickable: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 50,
                    slidesPerView: 4,
                },
                1024: {
                    spaceBetween: 50,
                    slidesPerView: 4,
                },
            },
        });
    }

    // show header based on scroll directions
    var lastScrollTop = 150;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
            $(".ticket-modal").removeClass('active');
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });
    //check if header is at top of page
    $(document).scroll(function () {
        if ($(this).scrollTop() > 150) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 150) {
            $("#wrapper-navbar").removeClass("off-top");
        }
    });

    //check if header is at top of page
    $(document).scroll(function () {
        if ($(this).scrollTop() > 500) {
            $(".back-to-top").addClass("off-top");
        }
        if ($(this).scrollTop() < 500) {
            $(".back-to-top").removeClass("off-top");
        }
    });
    //calc height for submenu

    //Service filter
    $(".filter").on("click", function () {
        var value = $(this).attr("data-id");
        if ($(".package").length == $(".package.active").length) {
            $(this).addClass("active");
            $(this).siblings().removeClass("active");
            $(".package[data-id=" + value + "")
                .siblings()
                .removeClass("active")
                .slideUp();
        } else if ($(".package.active").length == 1) {
            if ($(this).hasClass("active")) {
                return;
            } else {
                $(this).addClass("active");
                $(".package[data-id=" + value + "")
                    .addClass("active")
                    .slideDown();
            }
        } else if ($(".package").length != $(".package.active").length) {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(".package[data-id=" + value + "")
                    .removeClass("active")
                    .slideUp();
            } else {
                $(this).addClass("active");
                $(".package[data-id=" + value + "")
                    .addClass("active")
                    .slideDown();
            }
        }
    });

    //Mobile menu active state

    $("#menu-primary-menu-1 li").on("click", function() {
        $(this).toggleClass("active");
    })

    $("input.option").on("click", function () {
        // $(".option-wrapper").removeClass("active-filter");
        $(this).parent().toggleClass("active-filter");
    });
    $(".options-wrapper").children().first().addClass("first-filter");
    $("#filter .all").on("click", function (e) {
        $("#filter input").prop("checked", false);
        $("#filter").trigger("change");
        $("#filter .option-wrapper").removeClass("active-filter");
    });
    //questions
    var countQuestions = $(".question").length;
    var i = 1;
    var counter = 0;
    function checkResult() {
        if ($(".option:last-child").hasClass("active")) {
            $(".results .result").removeClass("active");
            $(".results .result:last-child").addClass("active");
        } else {
            $(".results .result:last-child").removeClass("active");
            $(".results .result:first-child").addClass("active");
        }
    }
    $(".question-wrapper .options .option").on("click", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        checkResult();
        $(this).parent().parent().addClass("active");
    });
    $(".question-wrapper .options .option").one("click", function () {
        $(this).siblings().addClass("selected");
    });
    $(".question-wrapper .options .option").one("click", function () {
        if ($(this).hasClass("selected")) {
            return true;
        } else {
            $(".steps .step." + counter).addClass("active");
            counter++;
        }

        if ($(".steps .step").length == $(".steps .active").length) {
            $(".section-results").slideUp("fast", function () {
                $(".section-results").addClass("done");
                $(".section-results").fadeIn();
            });
        }
    });
    while (i <= countQuestions) {
        $(".steps").append("<div class='step'></div>");
        i++;
    }
    $(".steps .step").each(function (y) {
        var $this = $(this);
        var newClass = "" + y++;
        $this.addClass(newClass);
    });

    //Contact popup
    $(".section-results").on("click", function () {
        $(this).fadeOut();
    });

    $(".section-contact .close").on("click", function () {
        $(".section-contact").removeClass("active");
        $("html").css("overflow-y", "visible");
    });
    //Contact popup
    $(".button.groen").on("click", function () {
        if ($(this).attr("href") === "#") {
            $(".section-contact").addClass("active");
            $("html").css("overflow-y", "hidden");
        }
    });
    //header
   
    //Cookies
    $(".cky-footer-wrapper").hide();

    $(".button").on("click", function () {
        if (this.href.indexOf("contactformulier") != -1) {
            $(".contact-forms-shadow").addClass("active");
            var formulier = this.href;
            var formulierId = formulier[formulier.length - 1];
            $(".contact-popup-" + formulierId + "").addClass("active");
        }
    });

    $(".contact-forms-shadow, .popup-close").on("click", function () {
        $(".contact-forms-shadow, .contact-popup").removeClass("active");
    });

    // smoooooth page scrolling
    // gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    // let smoother = ScrollSmoother.create({
    //     smooth: 2,   // seconds it takes to "catch up" to native scroll position
    //     effects: true // look for data-speed and data-lag attributes on elements and animate accordingly
    // });

    // $( window ).resize(function() {
    //     gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    //     let smoother = ScrollSmoother.create({
    //         smooth: 2,   // seconds it takes to "catch up" to native scroll position
    //         effects: true // look for data-speed and data-lag attributes on elements and animate accordingly
    //     });
    // });

    // new ResizeSensor(jQuery('.wrapper'), function() {
    //     gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    //     let smoother = ScrollSmoother.create({
    //         smooth: 2,   // seconds it takes to "catch up" to native scroll position
    //         effects: true // look for data-speed and data-lag attributes on elements and animate accordingly
    //     });
    // });

    // if ($(".line2").length > 0) {
    //     // Animated line SVG GSAP
    //     const GreenLine = $(".line2");
    //     const stops = $(".stop");

    //     TweenMax.set(GreenLine, { strokeWidth: 0.5, drawSVG: 0 });
    //     TweenMax.set(stops, { autoAlpha: 1, scale: 0, transformOrigin: "center" });

    //     // ==============================
    //     TweenLite.defaultEase = Power0.easeNone;
    //     const topEase = Elastic.easeOut.config(1.5, 1);

    //     // time should  be adjusted relative to window width
    //     // e.g. ww < 500  it should be 8 - 12
    //     const time = 9;
    //     const time02 = 3;
    //     const timestop01 = time / 5.55;
    //     const timestop02 = time / 2.68;
    //     const timestop03 = time / 1.8;
    //     const timestop04 = time / 1.4;
    //     const timestop05 = time / 1.03;
    //     const stop = 0.5;

    //     let action = new TimelineMax({ paused: true })
    //         .to(GreenLine, time, { drawSVG: "0% 65%" })
    //         .to(GreenLine, time02, { drawSVG: "0% 100%" }) // option: separate sections, individual timings
    //         .to(GreenLine, time, { strokeWidth: 0.5 }, 0)
    //         .to(".stop01", stop, { scale: 1 }, timestop01)
    //         .to(".end", 0.3, { autoAlpha: 1 }, timestop01)
    //         .to(".stop02", stop, { scale: 1 }, timestop02)
    //         .to(".stop03", stop, { scale: 1 }, timestop03)
    //         .to(".stop04", stop, { scale: 1 }, timestop04)
    //         .to(".stop05", stop, { scale: 1 }, timestop05);
    //     //.to('.end',stop,{autoAlpha:1},time + time02)

    //     // media query event handler
    //     let factor;

    //     const mq = window.matchMedia("(min-width: 500px)");

    //     if (matchMedia) {
    //         mq.addListener(WidthChange);
    //         WidthChange(mq);
    //     }

    //     // media query change
    //     function WidthChange(mq) {
    //         if (mq.matches) {
    //             factor = 0.95;
    //         } else {
    //             factor = 0.8;
    //         }
    //     }

    //     WidthChange(mq);

    //     // === scrolling sync  by requestAnimationFrame  ===========
    //     // Based on https://www.html5rocks.com/en/tutorials/speed/animations/#debouncing-scroll-events

    //     var latestKnownScrollY = 0,
    //         scrollDistance = 0,
    //         lastScrollTop = 0,
    //         scrollPercent = 0,
    //         ticking = false;

    //     function onScroll() {
    //         latestKnownScrollY = window.scrollY; //No IE8
    //         requestTick();
    //     }

    //     function update() {
    //         // reset the tick so we can
    //         // capture the next onScroll
    //         ticking = false;
    //         scrollDistance = $(".animated-line").height();

    //         scrollPercent =
    //             $(window).scrollTop() / (scrollDistance - $(window).height());

    //         let progressAction = scrollPercent; // factor x
    //         // console.log(progressAction)
    //         if (latestKnownScrollY > lastScrollTop) {
    //             // downscroll
    //             TweenLite.to(action, 0, {
    //                 progress: progressAction,
    //                 ease: Power0.easeNone,
    //             });
    //         } else {
    //             TweenLite.to(action, 0, {
    //                 progress: progressAction,
    //                 ease: Power0.easeNone,
    //             });
    //         }

    //         lastScrollTop = latestKnownScrollY;
    //     }

    //     function requestTick() {
    //         if (!ticking) {
    //             requestAnimationFrame(update);
    //         }
    //         ticking = true;
    //     }

    //     window.addEventListener("scroll", onScroll, false);

    //     // . lodash.js ===========
    //     $(window).on(
    //         "resize",
    //         _.debounce(function () {
    //             update();
    //         }, 400)
    //     );
    // }

    // if ($(window).width() > 992) {
    //     // Attractive button GSAP
    //     $(".content-type-two").mouseleave(function (e) {
    //         TweenMax.to(".content-type-two .button", 2, { x: 0, y: 0 });
    //     });

    //     $(".content-type-two").mouseenter(function (e) {
    //         TweenMax.to(".content-type-two .button", 2);
    //     });

    //     $(".content-type-two").mousemove(function (e) {
    //         callParallax(e);
    //     });

    //     $(".content-type-two .button").css("transition", "initial");

    //     function callParallax(e) {
    //         parallaxIt(e, ".content-type-two .button", 150);
    //     }

    //     function parallaxIt(e, target, movement) {
    //         var $this = $(".content-type-two");
    //         var relX = e.pageX - $this.offset().left;
    //         var relY = e.pageY - $this.offset().top;

    //         TweenMax.to(target, 2, {
    //             x: ((relX - $this.width() / 2) / $this.width()) * movement,
    //             y: ((relY - $this.height() / 2) / $this.height()) * movement,
    //             ease: Back.easeOut.config(1.7),
    //         });
    //     }
    // }



    
    // toggle status modal
    $(".circle-icons a:nth-child(2)").on("click", function () {
        $(".ticket-modal").toggleClass('active');
    });

    $(".ticket-modal .close").on("click", function () {
        $(".ticket-modal").removeClass('active');
    });


})(jQuery);
